@if (sheet_ready) {
  <div>
    <process-sheet-view [allProcesses]="allProcesses"
      [parent]="parent"
      [processes]="processes"
      [propertyCategories]="property_categories"
    ></process-sheet-view>
  </div>
}
